let btSdkPromise = null;

function loadBtSdk () {
    if (!btSdkPromise) {
        // Clear the cache on rejection so a transient import failure
        // doesn't poison every subsequent caller on the page.
        btSdkPromise = import(/* webpackChunkName: "basis-theory" */ '@basis-theory/web-elements')
            .catch((err) => { btSdkPromise = null; throw err; });
    }
    return btSdkPromise;
}

/**
 * Mint a short-lived Basis Theory client by fetching a session key
 * from the Symfony endpoint and hydrating the Elements SDK against it.
 *
 * The SDK import and session fetch run in parallel — they're
 * independent (dynamic chunk download vs same-origin POST) and
 * serializing them added ~150–300ms to BT-ready on slow connections.
 *
 * The SDK module promise is cached across calls, so multiple Alpine
 * components on the same page (e.g. the tabbed payment page renders
 * both the card and bank forms) share one chunk download.
 */
export async function createBasisTheoryClient (sessionUrl, { environment = 'test' } = {}) {
    const [sdk, sessionResponse] = await Promise.all([
        loadBtSdk(),
        fetch(sessionUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
        }),
    ]);

    if (!sessionResponse.ok) {
        throw new Error(`Failed to fetch Basis Theory session (${sessionResponse.status})`);
    }

    const { session_key: sessionKey } = await sessionResponse.json();
    if (typeof sessionKey !== 'string' || sessionKey === '') {
        throw new Error('Basis Theory session response missing session_key.');
    }

    return sdk.basistheory(sessionKey, { environment });
}
